// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2wLEW","left":"InfoRow_left__2tX2p"};